
import styled from "styled-components";

export const Magic8BallDisclaimerDefaultBox = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 1rem 1rem;
    text-align: justify;
    line-height: 1.2;
`;
